import { ButtonProps } from '@chakra-ui/react';
import { useCallback } from 'react';
import Button from '~/components/Button';
import { convertPxToRems } from '~/utils-ts';

interface Props extends ButtonProps {
  title?: string;
  onClear: () => void;
}

export const ClearAllFiltersButton: React.FC<Props> = ({
  title = 'Clear All Filters',
  onClear,
  ...props
}) => {
  const clearAllFilters = useCallback(() => {
    onClear();
  }, [onClear]);

  return (
    <Button
      maxWidth={convertPxToRems(110)}
      color="primary.400"
      variant="ghost"
      onClick={clearAllFilters}
      fontSize="md"
      textColor="primary.600"
      {...props}
    >
      {title}
    </Button>
  );
};
